import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { PARTNER_OFFER_CONDITIONS } from 'site-modules/shared/constants/appraisal/appraisal';
import { usePrevious } from 'site-modules/shared/hooks/use-previous';
import { getHistoryTrendCopy } from 'site-modules/shared/utils/appraisal/appraisal-history';
import { LicensePlateAndVinStepContext } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/license-plate-and-vin-step/license-plate-and-vin-step-context';

export const LicensePlateAndVinStepWrapper = ({
  children = null,
  zipCode = '',
  mileage = '',
  options = [],
  condition = '',
  vehicle = {},
  activeStepId = '',
}) => {
  const [isLoading, setIsLoading] = useState();
  const [isHistoryTrendUp, setIsHistoryTrendUp] = useState(null);
  const [isNoTmvData, setIsNoTmvData] = useState(false);
  const styleId = vehicle?.style?.id;

  const prevActiveStepId = usePrevious(activeStepId);

  useEffect(() => {
    const updateHistoryTrend = async () => {
      setIsLoading(true);

      const { showDownwardTrendCopy, noTmvData } = await getHistoryTrendCopy({
        zipCode,
        mileage,
        optionIds: options.map(({ id }) => id).join(','),
        condition,
        styleId,
        creativeId: 'edm-entry-epo-vin',
        predictionCreativeId: 'edm-entry-epo-vin',
      });

      setIsHistoryTrendUp(!showDownwardTrendCopy);
      setIsNoTmvData(noTmvData);
      setIsLoading(false);
    };

    if (activeStepId === PARTNER_OFFER_CONDITIONS && prevActiveStepId !== PARTNER_OFFER_CONDITIONS) {
      updateHistoryTrend();
    }
  }, [activeStepId, condition, mileage, options, prevActiveStepId, styleId, zipCode]);

  const contextProps = useMemo(
    () => ({
      isHistoryTrendUp,
      isNoTmvData,
      isHistoryTrendLoading: isLoading,
    }),
    [isHistoryTrendUp, isNoTmvData, isLoading]
  );

  return (
    <LicensePlateAndVinStepContext.Provider value={contextProps}>{children}</LicensePlateAndVinStepContext.Provider>
  );
};

LicensePlateAndVinStepWrapper.propTypes = {
  children: PropTypes.node,
  zipCode: PropTypes.string,
  mileage: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  condition: PropTypes.string,
  vehicle: PropTypes.shape({}),
  activeStepId: PropTypes.string,
  vin: PropTypes.string,
  isStepActive: PropTypes.bool,
};
